import $ from "jquery";
import _ from "lodash";
import ScrollMagic from "scrollmagic";
import "debug.addIndicators";

import controller from "../scroll/controller";

$(".block-sticky-phone").each(function() {
  let $block = $(this);
  let block = $block[0];
  let blockH = $block.height();

  let $sticky = $block.find(".sticky");
  let sticky = $sticky[0];
  let stickyH = $sticky.height();

  let scenes = [];

  let $image = $block.find(".image");
  let imageCount = $image.length;

  let $texts = $block.find(".texts");
  let $text = $block.find(".text");
  let textCount = $text.length;

  let $columnLeft = $block.find(".column-left");
  let $columnRight = $block.find(".column-right");

  let $firstText = $block.find(".text-0");
  let $firstLText = $block.find(".text-0");
  let $firstRText = $block.find(".text-1");

  let firstTextH = $text.first().height();
  let lastTextH = $text.last().height();

  const textHeight = () => {
    $text.css({ height: stickyH, "margin-top": stickyH });
    $firstLText.css({ "margin-top": 0 });
    $firstRText.css({ "margin-top": 0 });
  };

  const columnLeftSpacing = () => {
    let firstSpacing = stickyH / 2 - firstTextH / 2;
    let lastSpacing = stickyH / 2 - lastTextH / 2;

    $columnLeft.css({
      "padding-top": firstSpacing,
      "padding-bottom": lastSpacing
    });
  };

  const columnRightSpacing = () => {
    let firstSpacing = stickyH;

    $columnRight.css({
      "padding-top": firstSpacing
    });
  };

  const deleteScenes = () => {
    if (scenes.length) {
      scenes.forEach(function(scene) {
        scene.destroy(true);
      });
    }
  };

  const showFirstText = () => {
    $firstText.addClass("show");
  };

  const enterTextScene = (event, index, $element) => {
    $element.addClass("show");
    let image = $element.data("image");
    $(image).addClass("show");
  };

  const leaveTextScene = (event, index, $element) => {
    let first = $element.hasClass("text-0");
    let last = $element.hasClass(`text-${textCount - 1}`);
    if (event.scrollDirection == "REVERSE" && first) return;
    if (event.scrollDirection == "FORWARD" && last) return;
    $element.removeClass("show");
    let image = $element.data("image");
    $(image).removeClass("show");
  };

  const blockScene = () => {
    blockH = $block.height();
    stickyH = $sticky.height();

    const scene = new ScrollMagic.Scene({
      duration: blockH - stickyH,
      offset: stickyH / 2,
      triggerHook: "onCenter",
      triggerElement: block
    })
      .setPin(sticky)
      // .addIndicators()
      .addTo(controller);
    scenes.push(scene);
  };

  const textScenes = () => {
    $text.each(function(index) {
      let $this = $(this);

      let scene = new ScrollMagic.Scene({
        duration: $this.outerHeight(),
        offset: 0,
        triggerHook: 0.5,
        triggerElement: $this[0]
      })
        // .addIndicators()
        .addTo(controller)
        .on("enter", function(event) {
          enterTextScene(event, index, $this);
        })
        .on("leave", function(event) {
          leaveTextScene(event, index, $this);
        });
      scenes.push(scene);
    });
  };

  const init = () => {
    deleteScenes();
    if (window.innerWidth > 768) {
      showFirstText();
      textHeight();
      // columnLeftSpacing();
      columnRightSpacing();
      blockScene();
      textScenes();
    }
  };

  init();
  $(window).on("resize", _.debounce(init, 100));
});
